<template>

  <div id="app">
    <site-header></site-header>
    <div
      class="main-app-container"
      :class="containerClass"
    >
      <router-view />
    </div>
    <site-footer></site-footer>
    <vue-snotify />
    <v-dialog/>
  </div>

</template>

<script>
  import EventBus from '@/helpers/event-bus';
  import SiteHeader from './components/layout/SiteHeader';
  import SiteFooter from './components/layout/SiteFooter';

  import jquery from 'jquery';

  export default {
    name: 'App',
    computed: {
      containerClass() {
        return this.$store.state.app.containerClass;
      },
    },

    async mounted () {
      jquery(document).ready(function(){
        jquery(window).scroll(function(){
          if (jquery(window).scrollTop() > 0) {
            jquery('body').addClass('scrolled');
          }
          else {
            jquery('body').removeClass('scrolled');
          }
        });
      });

      if (this.$store.state.user.token) {
        await this.$store.dispatch('user/getUserInfo');
      }
      EventBus.$on('snotifySuccess', function (payload) {
        this.$snotify.success(payload);
      });
      EventBus.$on('snotifyError', function (payload) {
        this.$snotify.error(payload);
      });
    },

    components: {
      SiteHeader, SiteFooter
    }
  };

</script>

<style>
  #app {
    flex: 1 0 auto;
  }

  #sticky-footer {
    flex-shrink: none;
  }
</style>
